import React from 'react';
import { Button } from '@kaseyaitglue/kaseya-ui';
import {
  ERROR_DESCRIPTION,
  ERROR_TITLE,
  ERROR_STATE_VARIANTS,
  NETWORK_DESCRIPTION,
  NETWORK_TITLE,
  RETRY_LABEL,
  TEST_ID_PREFIX,
} from './constants';
import {
  DescriptionStyled,
  ErrorIconStyled,
  ErrorStateContainerStyled,
  RetryButtonWrapperStyled,
  TitleStyled,
} from './styles';
import { ErrorStateProps, ErrorStateVariant } from './types';
import ErrorIcon from '@images/error.svg';
import NoConnectionIcon from '@images/no-connection.svg';

const VARIANT_CONTENT: Record<ErrorStateVariant, { icon: string; title: string; description: string[] }> = {
  [ERROR_STATE_VARIANTS.ERROR]: {
    icon: ErrorIcon,
    title: ERROR_TITLE,
    description: ERROR_DESCRIPTION,
  },
  [ERROR_STATE_VARIANTS.NETWORK]: {
    icon: NoConnectionIcon,
    title: NETWORK_TITLE,
    description: NETWORK_DESCRIPTION,
  },
};

const ErrorState = ({
  variant = ERROR_STATE_VARIANTS.ERROR,
  title,
  description,
  onRetry,
  showRetry = true,
  fullScreen = false,
  testId = TEST_ID_PREFIX,
}: ErrorStateProps) => {
  const content = VARIANT_CONTENT[variant];
  const handleRetry = () => (onRetry ? onRetry() : window.location.reload());

  return (
    <ErrorStateContainerStyled $fullScreen={fullScreen} data-testid={`${testId}-block`}>
      <ErrorIconStyled src={content.icon} alt="" aria-hidden="true" />
      <TitleStyled data-testid={`${testId}-title`}>{title ?? content.title}</TitleStyled>

      {(description ?? content.description).map((line) => (
        <DescriptionStyled key={line}>{line}</DescriptionStyled>
      ))}

      {showRetry && (
        <RetryButtonWrapperStyled>
          <Button variant="secondary" onClick={handleRetry} data-testid={`${testId}-retry-button`}>
            {RETRY_LABEL}
          </Button>
        </RetryButtonWrapperStyled>
      )}
    </ErrorStateContainerStyled>
  );
};

export default ErrorState;
